import { BoltIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';

const STEP = 50;

type PlanCardProps = {
    name: string;
    includedEntities: number;
    price: number;
    additionalEntitiesCost: number;
    isActive?: boolean;
    onClick?: () => void;
    disabled?: boolean;
};

function PlanCard({
    name,
    includedEntities,
    price,
    additionalEntitiesCost,
    isActive = false,
    onClick,
    disabled = false,
}: PlanCardProps): JSX.Element {
    return (
        <div
            className={clsx(
                isActive
                    ? 'border-primary border-2 bg-indigo-50'
                    : 'border-borderPrimary hover:bg-indigo-50 hover:border-indigo-600 hover:border-2',
                'border rounded-lg border-borderPrimary p-4 cursor-pointer',
                disabled && 'pointer-events-none'
            )}
            onClick={(): void => {
                if (!disabled) {
                    onClick?.();
                }
            }}
        >
            <h3 className="text-contentPrimary font-bold relative">
                {name} {isActive && <BoltIcon className="h-5 w-5 text-primary absolute right-0 top-0" />}
            </h3>
            <p className="text-xs text-contentSecondary mt-1">Includes {includedEntities} entities</p>
            <p className="text-xs text-contentSecondary mt-1">
                Additional {STEP} entities (per month): ${additionalEntitiesCost}
            </p>
            <div className="mt-8 mb-1">
                <p className="text-lg font-bold text-contentPrimary">
                    A${price} <span className="text-sm text-contentSecondary font-normal">per month</span>
                </p>
            </div>
        </div>
    );
}

export default PlanCard;
